import React from "react";
import "../pages/Proyect.css";
import htmlp from "../Assets/html_p.png";
import cssp from "../Assets/css_p.png";
import jsp from "../Assets/js_p.png";
import transmuta from "../Assets/gif-desk.png";
import BackButton from "../componets/BackButton";
import firee from "../Assets/firebase_p.png";


export const GifApp = () => {
        const handleWebButtonClick = () => {
    window.location.href = "https://655d2481e2e9a4173d98026b--gif-fav.netlify.app/"; // Reemplaza con la URL que quieras
  };

  const handleGitHubButtonClick = () => {
    window.location.href = "https://github.com/SusanaLab/GifApp"; // Reemplaza con la URL de tu repositorio en GitHub
  };
  return (
    <div className="proyect-container">
      <BackButton/>
      <div className="proyect-header">
        <h1>Gif fav</h1>
     
      <div className="proyect-description">
        <p>
        I developed the "Gif Fav" web application with the aim of providing users with an interactive platform to search and discover their favorite GIFs across a wide range of topics. Using React technology, the application offers a fast and accurate experience, allowing users to get up to 6 GIFs related to their searches. With an intuitive interface, "Gif Fav" provides instant results for enjoying fun and entertaining moments on the spot. Explore the world of animation and find the perfect dose of fun for every occasion with "Gif Fav."
        </p>
      </div>
      <div className="proyect-buttons">
         <button className="proyect-button" onClick={handleWebButtonClick}>Web</button>
      <button className="proyect-button" onClick={handleGitHubButtonClick}>GitHub</button>
      </div>
      <div className="proyect-tech">
        <p>Technologies</p>
        <img src={htmlp} alt="HTML" className="computer" />
        <img src={cssp} alt="CSS" className="computer" />
      
      </div> </div>
      <img
        src={transmuta}
        alt="Learning List"
        id="new"
      />
    </div>
  );
};

